import * as Yup from "yup";
import { differenceInDays } from "date-fns";

export const TwilioPatientFilterSchema = Yup.object().shape({
  type: Yup.string().required("Type is required"),
  startDate: Yup.string()
    .nullable()
    .required("Start Date is required")
    .test(
      "is-before-end",
      "Start Date cannot be after End Date",
      function (startDate) {
        const { endDate } = this.parent;
        return endDate ? new Date(startDate) <= new Date(endDate) : true;
      }
    )
    .test(
      "is-in-range",
      "The date range cannot exceed one year",
      function (startDate) {
        const { endDate } = this.parent;
        if (startDate && endDate) {
          const diffDays = differenceInDays(
            new Date(endDate),
            new Date(startDate)
          );
          return diffDays <= 365; // 1 year range
        }
        return true;
      }
    ),
  endDate: Yup.string()
    .nullable()
    .required("End Date is required")
    .test(
      "is-after-start",
      "End Date cannot be before Start Date",
      function (endDate) {
        const { startDate } = this.parent;
        return startDate ? new Date(endDate) >= new Date(startDate) : true;
      }
    )
    .test(
      "is-in-range",
      "The date range cannot exceed one year",
      function (endDate) {
        const { startDate } = this.parent;
        if (startDate && endDate) {
          const diffDays = differenceInDays(
            new Date(endDate),
            new Date(startDate)
          );
          return diffDays <= 365; // 1 year range
        }
        return true;
      }
    ),
});
